import React, { useState } from "react";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import { useMutation } from "@apollo/client";
import { userClient } from "../../apolloClient";
import { SEND_INVITE } from "../../mutation/sendInvite";

const MultiEmail = ({ setIsInviteSuccess }) => {
  const [emails, setEmails] = useState([]);

  const [sendInvite] = useMutation(SEND_INVITE, {
    client: userClient,
  });

  return (
    <div className={`multiple-email-row ${emails.length ? "" : "disable"}`}>
      <ReactMultiEmail
        placeholder="Email addresses..."
        emails={emails}
        onChange={(_emails) => {
          setEmails(_emails);
        }}
        validateEmail={(email) => {
          return isEmail(email);
          //return boolean
        }}
        getLabel={(email, index, removeEmail) => {
          return (
            <div data-tag key={index}>
              {email}
              <span data-tag-handle onClick={() => removeEmail(index)}>
                ×
              </span>
            </div>
          );
        }}
      />
      <button
        className="button"
        onClick={() => {
          if (emails.length) {
            sendInvite({
              variables: {
                email: emails,
              },
            })
              .then(() => {
                setEmails([]);
                setIsInviteSuccess(true);
              })
              .catch(() => {});
          }
        }}
      >
        Send invite
      </button>
    </div>
  );
};

export default MultiEmail;
